<div class="title" mat-dialog-title>Désactivation d'une configuration</div>
<div class="dialog-container-content">
  Voulez-vous réellement désactiver la configuration <b>{{data.configId}}</b> ?
</div>
<div class="dialog-container-button">
  <button mat-button class="mr10" (click)="closeDialog()">Fermer</button>
  <button mat-button class="primary-btn" (click)="confirmDesactivation()">Valider</button>
</div>
